import {SPACESHIP_BOTTOM_OFFSET} from './ClickerGame.constants';
import {ClickerGCSEngine} from './ClickerGame.types';
import {BackgroundGalaxy} from './game-objects/BackgroundGalaxy/BackgroundGalaxy';
import {ResultsBackgroundGalaxy} from './game-objects/BackgroundGalaxy/ResultsBackgroundGalaxy';
import {BonusDestroyEffect} from './game-objects/BonusDestroyEffect/BonusDestroyEffect';
import {EmittersContainer} from './game-objects/EmittersContainer/EmittersContainer';
import {PointsEmitter} from './game-objects/PointsEmitterPool/PointsEmitter';
import {ResultsSpaceship} from './game-objects/Spaceship/ResultsSpaceship';
import {Spaceship} from './game-objects/Spaceship/Spaceship';
import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

export class ClickerGameSpawner {
  constructor(
    private readonly gcsEngine: ClickerGCSEngine,
    private readonly spaceshipFactory: () => Spaceship,
    private readonly resultsSpaceshipFactory: () => ResultsSpaceship,
    private readonly backgroundFactory: () => BackgroundGalaxy,
    private readonly resultsBackgroundFactory: () => ResultsBackgroundGalaxy,
    private readonly bonusDestroyEffectFactory: () => BonusDestroyEffect,
    private readonly pointsEmitterFactory: () => PointsEmitter,
    private readonly emittersContainerFactory: () => EmittersContainer,
  ) {}

  public spawnPointsEmitter(): void {
    const pointsEmitter = this.pointsEmitterFactory();
    this.gcsEngine.world.addGameObject(pointsEmitter);
  }

  public spawnEmittersContainer(): void {
    const emittersContainer = this.emittersContainerFactory();
    this.gcsEngine.world.addGameObject(emittersContainer);
  }

  public spawnSpaceship(): void {
    const spaceship = this.spaceshipFactory();
    this.gcsEngine.world.addGameObject(spaceship);

    const dimensions = this.gcsEngine.renderer.renderer.getFrameDimensions();

    spaceship.transformComponent.y = dimensions.height - spaceship.viewComponent.height / 2 - SPACESHIP_BOTTOM_OFFSET;
    spaceship.transformComponent.x = dimensions.width / 2;
  }

  public spawnResultsSpaceship(): void {
    const spaceship = this.resultsSpaceshipFactory();
    this.gcsEngine.world.addGameObject(spaceship);

    const dimensions = this.gcsEngine.renderer.renderer.getFrameDimensions();

    spaceship.transformComponent.y = dimensions.height - spaceship.viewComponent.height / 2 - SPACESHIP_BOTTOM_OFFSET;
    spaceship.transformComponent.x = dimensions.width / 2;
  }

  public spawnBackground(): void {
    const background = this.backgroundFactory();

    this.gcsEngine.world.addGameObject(background);
  }

  public spawnResultsBackground(): void {
    const background = this.resultsBackgroundFactory();

    this.gcsEngine.world.addGameObject(background);
  }

  public spawnBonusDestroyEffect(): void {
    const bonusDestroyEffect = this.bonusDestroyEffectFactory();
    this.gcsEngine.world.addGameObject(bonusDestroyEffect);
  }
}

injected(
  ClickerGameSpawner,
  DI_TOKENS.gcsEngine,
  DI_TOKENS.clickerGameSpaceship,
  DI_TOKENS.clickerGameResultsSpaceship,
  DI_TOKENS.clickerGameBackgroundGalaxy,
  DI_TOKENS.clickerGameResultsBackgroundGalaxy,
  DI_TOKENS.clickerGameBonusDestroyEffect,
  DI_TOKENS.clickerGamePointsEmitter,
  DI_TOKENS.clickerGameEmittersContainer,
);
